import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UploadIcon, FileIcon, XIcon, CheckCircleIcon, AlertCircleIcon, DownloadIcon, SearchIcon, ChevronRightIcon, ArrowUpDownIcon, InfoIcon } from 'lucide-react';
import Papa from 'papaparse';
import { BulkPaymentList } from '../components/BulkPaymentList';
import { BulkPaymentUpload } from '../components/BulkPaymentUpload';
export type BulkPaymentStatus = 'draft' | 'processing' | 'completed' | 'failed';
export type PaymentStatus = 'pending' | 'paid' | 'expired' | 'failed' | 'cancelled';
export interface PaymentItem {
  id: string;
  customerName: string;
  email: string;
  phone: string;
  amount: string;
  currency: string;
  description: string;
  reference: string;
  status: PaymentStatus;
  dueDate?: string;
}
export interface BulkPaymentBatch {
  id: string;
  name: string;
  createdAt: string;
  totalAmount: number;
  currency: string;
  totalItems: number;
  completedItems: number;
  status: BulkPaymentStatus;
  collectionRate: number;
}
export function BulkPayments() {
  const [activeTab, setActiveTab] = useState<'upload' | 'batches'>('batches');
  const navigate = useNavigate();
  return <div data-id="element-2506">
      {/* Header with title */}
      <div className="mb-6 flex justify-between items-center" data-id="element-2507">
        <h2 className="text-lg font-medium text-gray-800" data-id="element-2508">
          Bulk Payment Requests
        </h2>
        <div data-id="element-2509">
          {activeTab === 'batches' && <button onClick={() => setActiveTab('upload')} className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-md transition-colors" data-id="element-2510">
              Create New Batch
            </button>}
          {activeTab === 'upload' && <button onClick={() => setActiveTab('batches')} className="px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-md transition-colors" data-id="element-2511">
              View All Batches
            </button>}
        </div>
      </div>
      {/* Tabs */}
      <div className="border-b border-gray-200 mb-6" data-id="element-2512">
        <div className="flex space-x-8" data-id="element-2513">
          <button className={`text-sm font-medium pb-4 ${activeTab === 'upload' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab('upload')} data-id="element-2514">
            Upload New Batch
          </button>
          <button className={`text-sm font-medium pb-4 ${activeTab === 'batches' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab('batches')} data-id="element-2515">
            Batch History
          </button>
        </div>
      </div>
      {/* Content based on active tab */}
      {activeTab === 'upload' ? <BulkPaymentUpload onBatchCreated={() => setActiveTab('batches')} data-id="element-2516" /> : <BulkPaymentList onViewDetail={batchId => navigate(`/bulk-payment-detail/${batchId}`)} data-id="element-2517" />}
    </div>;
}